import { render, staticRenderFns } from "./NewMatrixAcademicYear.vue?vue&type=template&id=f76e2bc6&"
import script from "./NewMatrixAcademicYear.vue?vue&type=script&lang=js&"
export * from "./NewMatrixAcademicYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports